import { useState, useEffect } from 'react';
import Select from 'react-select';
import cleanFilename from './util.js';
import { Link } from 'react-router-dom';



function Links(){
  const [name, setName] = useState('');
    const [amount, setAmount] = useState('');
    const [email, setEmail] = useState('');
    const [links, setLinks] = useState([]);
    const [rawSongs, setRawSongs] = useState([[]]);
    const [pickedSongs, setPickedSongs] = useState([]);

    // GET SONGS BASED ON EMAIL CHANGING 
    useEffect(() => {
        if(!email){
          return;
        } else {
          const timeout = setTimeout(async () => {
            try{
          const res = await fetch('/links/songs', {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              email
            })
          });
          const data = await res.json();
          const cleanSongs = data.songs.map(song => cleanFilename(song));
          setRawSongs(data.songs.map((raw, i) => ({raw, clean: cleanSongs[i]})));
          } catch(err){console.error(err);}
            }, 1000); 
              return () => clearTimeout(timeout);
        }
    }, [email]);

  // FUNCTION THAT SELECTS SONGS FROM UI
  const pickSongs = (selected) => {
    setPickedSongs(selected);
    console.log('songs selected');
   } 
   // FUNCTION THAT GETS DOWNLOAD LINK(S) OF SELECTED SONGS
    async function getLinks(){
        // frontend to display list of links after button click
        const rawSelected = pickedSongs.map(song => song.value); // get songs from frontend to send back for download
        try{
            const res = await fetch('/links/linc',
          {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              name,
              email,
              amount,
              song: rawSelected})
          });
             if(!res.ok) throw new Error('Links didnt work'); 
                // get links
            const data = await res.json();
             if (data.exists) {
                alert(`The name "${data.name}" already exists! Choose a different one.`);
                return; // stop here
    }
            setLinks(Array.isArray(data.endpoint) ? data.endpoint : []);
        } catch(err) {console.error(err);}
    }
    return (
        <div>
          <Link to='/juug'><button>See your juugs</button></Link>
          <div>
          <p>Pick songs:</p>
           {rawSongs.length > 0 && (<Select
              isMulti
              options={rawSongs.map(song => ({value: song.raw, label: song.clean}))}
              value={pickedSongs}
              onChange={pickSongs}
            />)}
        </div>
            <form id='downloadForm' onSubmit={(e) => {e.preventDefault(); getLinks()}}>
            <p>Name your juug:</p><input type='text' onChange={e => setName(e.target.value)}></input>
            <p>amount</p><input type='text' onChange={e => setAmount(e.target.value)}></input>
            <p>email </p><input type='text' onChange={e => {e.preventDefault(); setEmail(e.target.value)}}></input>
            <button type='submit'>Links</button>
            </form>

        <ol>
{
Array.isArray(links) && links.length > 0 ? (
  links.map((v, k) => (
    <li key={k}>
      <a
        href={`http://undergroundradio.us/musicv2/?token=${v}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        http://undergroundradio.us/musicv2/?token={v}
      </a>
    </li>
  ))
) : (
  <p>No links yet!</p>
)
}
</ol>
        </div>
    )
}



export default Links;